import { render, staticRenderFns } from "./BimEngineeringChangeItemDetail.vue?vue&type=template&id=4a1ba8ef"
import script from "./BimEngineeringChangeItemDetail.vue?vue&type=script&lang=js"
export * from "./BimEngineeringChangeItemDetail.vue?vue&type=script&lang=js"
import style0 from "./BimEngineeringChangeItemDetail.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports